import { string } from "prop-types"
import { api } from "utils/api"
import { useToast, ToastProvider } from "components/ui/Toast"

const ExportCsvButtonWrapper = props => {
  return (
    <ToastProvider>
      <ExportCsvButton {...props} />
    </ToastProvider>
  )
}

const ExportCsvButton = ({ path, className }) => {
  const { addToast } = useToast()

  const handleClick = () => {
    api.post(path).then(_ => addToast("You will receive an email when your export is ready"))
  }

  return (
    <button className={className} type="submit" onClick={handleClick}>
      Export CSV
    </button>
  )
}

ExportCsvButton.propTypes = {
  path: string.isRequired,
  className: string
}

export default ExportCsvButtonWrapper
